export default {
    /**
     * 获取富文本第一张图片并添加域名
     * @param {*} str
     * @returns img
     */
    getFirstImg (str) {
        var data = ''
        str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, function (match, capture) {
                // capture = 'http://wwwadmin2.gdsoke.com' + capture
                // data.push(capture)
                data = 'http://wwwadmin2.gdsoke.com' + capture
        })
        console.log('img:', data)
        return data
    },
    /**
     * 富文本图片添加域名
     * @param {*} content
     * @returns  data
     */
    replaceStr (content) {
        var imgInfo = /<img [^>]*src=['"]([^'"]+)[^>]*>/g // img 标签取src里面内容的正则
        var allImg = content.match(imgInfo) // 取到所有img标签 放到数组allImg里面
        if (allImg) { // 可能没有匹配
            for (var i = 0; i < allImg.length; i++) {
                var srcImg = allImg[i].replace(imgInfo, '$1') // 取src面的内容
                if (srcImg.slice(0, 4) === 'http' || srcImg.slice(0, 5) === 'https') {
                    // 匹配http，https，看需求是否处理
                } else {
                    // 修改富文本字符串内容 img标签src 相对路径改为绝对路径
                    content = content.replace(new RegExp(srcImg, 'g'), 'http://wwwadmin2.gdsoke.com' + srcImg) // getEnvConfig().photoUrl 是替换地址
                }
            }
        }
        return content
    }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js